<template>
  <div
    id="login"
    style="min-height: calc(100vh - 20px)"
    class="fill-height d-flex align-items-center justify-content-center"
    tag="section"
  >
    <b-row class="justify-content-center no-gutters w-100">
      <b-col lg="5" md="6" sm="8" cols="11" class="d-flex align-items-center">
        <b-card no-body class="w-100">
          <b-row class="no-gutters">
            <b-col lg="12">
              <div class="p-4">
                <img src="@/assets/images/logo-icon.png" />
                <h2 class="font-weight-bold mt-4">Admin Sign in</h2>
                <h6 class="mb-4 text-muted">
                  Sign in to access Alphazzz Admin Console
                </h6>

                <!-- Error Alert -->
                <b-alert
                  v-if="errorMessage"
                  show
                  variant="danger"
                  dismissible
                  @dismissed="errorMessage = ''"
                >
                  {{ errorMessage }}
                </b-alert>

                <b-form @submit.prevent="handleLogin">
                  <b-form-group label="Email or Username">
                    <b-form-input
                      id="txt-username"
                      type="text"
                      placeholder="Enter your email or username"
                      class="mb-3"
                      v-model="$v.form.username.$model"
                      :state="validateState('username')"
                    ></b-form-input>
                    <b-form-invalid-feedback id="txt-username"
                      >Username/Email is required (min 4 characters)</b-form-invalid-feedback
                    >
                  </b-form-group>
                  <b-form-group label="Password">
                    <b-form-input
                      id="txt-pwd"
                      type="password"
                      placeholder="Enter your password"
                      class="mb-3"
                      v-model="$v.form.pwd.$model"
                      :state="validateState('pwd')"
                    ></b-form-input>
                    <b-form-invalid-feedback id="txt-pwd"
                      >Password is required (min 8 characters)</b-form-invalid-feedback
                    >
                  </b-form-group>

                  <div class="d-flex align-items-center">
                    <b-form-checkbox
                      id="checkbox-1"
                      v-model="rememberMe"
                      name="checkbox-1"
                    >
                      Remember me
                    </b-form-checkbox>

                    <div class="ml-auto">
                      <a href="javascript:void(0)" class="link">Forgot password?</a>
                    </div>
                  </div>
                  <b-button
                    type="submit"
                    variant="primary"
                    :disabled="$v.form.$invalid || loading"
                    size="lg"
                    block
                    class="mt-4"
                  >
                    <b-spinner small v-if="loading" class="mr-2"></b-spinner>
                    {{ loading ? 'Signing in...' : 'Sign In' }}
                  </b-button>
                </b-form>

              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "BoxedLogin",
  mixins: [validationMixin],
  data: () => ({
    form: {
      username: "",
      pwd: "",
    },
    rememberMe: false,
    errorMessage: "",
    loading: false,
  }),
  computed: {
    ...mapGetters("auth", ["isAuthenticated", "authError"]),
  },
  mounted() {
    // If already authenticated, redirect to dashboard
    if (this.isAuthenticated) {
      this.$router.push("/admin/dashboard");
    }
  },
  validations: {
    form: {
      username: {
        required,
        minLength: minLength(4),
      },
      pwd: {
        required,
        minLength: minLength(6),
      },
    },
  },
  methods: {
    ...mapActions("auth", ["login"]),
    
    validateState(field) {
      const { $dirty, $error } = this.$v.form[field];
      return $dirty ? !$error : null;
    },
    
    async handleLogin() {
      this.$v.form.$touch();
      
      if (this.$v.form.$invalid) {
        return;
      }
      
      this.loading = true;
      this.errorMessage = "";
      
      try {
        const credentials = {
          email: this.form.username,
          password: this.form.pwd,
        };
        
        await this.login(credentials);
        
        // Get redirect path from query or default to dashboard
        const redirect = this.$route.query.redirect || "/admin/dashboard";
        this.$router.push(redirect);
        
        // Show success message
        this.$bvToast.toast("Welcome to Alphazzz Admin Console!", {
          title: "Login Successful",
          variant: "success",
          solid: true,
          autoHideDelay: 3000,
        });
      } catch (error) {
        this.errorMessage = error.response?.data?.message || "Invalid credentials. Please try again.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>